import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { addToCart, reRenderShopifySections } = utils

class HHFormSelectTeas extends LitElement {
  static properties = {
    collectionHandle: {
      type: String,
      attribute: 'collection-handle',
    },
    greetingCardHandle: {
      type: String,
      attribute: 'greeting-card-handle',
    },
    maxProductLayer: {
      type: Number,
      attribute: 'max-product-layer',
    },
    activeVariant: {
      type: Number,
      attribute: 'active-variant',
    },
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
  }

  constructor() {
    super()

    this.modal = document.querySelector('#js-product-select-teas-modal')
    this.collectionHandle = ''
    this.maxProductLayer = 0
    this.activeVariant = 0
    this.remainingProduct = 0
    this.quantityValue = 0
    this.collectionJson = {}
    this.greetingCardJson = {}
    this.productCards = [...this.querySelectorAll('.js-product-select-card')]
    this.greetingCards = [
      ...this.querySelectorAll(
        '.js-product-select-card[data-product-collection="greeting-card"]'
      ),
    ]
    this.addProductBtns = [
      ...this.querySelectorAll('.product-select-teas__card-add-btn'),
    ]
    this.selectedProducts = []
    this.selectedGreetingCard = {}
    this.emptyGreetingCard = {
      id: '0',
      title: 'No Card',
      price: 0.0,
    }
    this.alreadyOnReview = false
    this.selectionStep = this.querySelector(
      `.form-select-teas__step-item[data-step="selection"]`
    )
    this.greetingStep = this?.querySelector(
      `.form-select-teas__step-item[data-step="greeting"]`
    )
    this.reviewStep = this.querySelector(
      `.form-select-teas__step-item[data-step="review"]`
    )
  }

  connectedCallback() {
    super.connectedCallback()
    this.fetchCollectionJson()
    this.remainingProduct = this.maxProductLayer
    this.productCards.forEach((product) => {
      product.addEventListener('click', this.onClickProductCard.bind(this))
    })
    this.addProductBtns.forEach((btn) => {
      btn.addEventListener('click', this.addProduct.bind(this))
    })

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getDataFromBroadCast(...args)
    })
    this.selectedGreetingCard = this.emptyGreetingCard
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  getDataFromBroadCast(data) {
    if (data.isTea) {
      this.quantityValue = data.value
      this.remainingProduct = this.remainingProduct - this.quantityValue

      this.updateMaxInput(data.key, this.remainingProduct)

      const maxLayerLabelElem = this.querySelector(
        '.js-select-layer-label[data-step="selection"] .label'
      )
      maxLayerLabelElem.textContent =
        this.maxProductLayer - this.remainingProduct

      this.isFull(this.remainingProduct)

      this.toggleProduct(data.key)
    } else {
      const maxLayerLabelElem = this.querySelector(
        '.js-select-layer-label[data-step="greeting"] .label'
      )
      maxLayerLabelElem.textContent = data.value == 1 ? 'Card' : 'None'
      this.disableOtherGiftCards(data.key)
      this.toggleGreetingProduct(data.key)
    }
  }

  fetchCollectionJson() {
    fetch(`/collections/${this.collectionHandle}?view=json`)
      .then((response) => response.json())
      .then((data) => {
        this.collectionJson = data
      })

    if (this.greetingCardHandle) {
      fetch(`/collections/${this.greetingCardHandle}?view=json`)
        .then((response) => response.json())
        .then((data) => {
          this.greetingCardJson = data
        })
    }
  }

  removeActiveClass() {
    this.productCards.forEach((product) => {
      product.classList.remove('active')
    })
  }

  onClickProductCard(event) {
    if (event.currentTarget.classList.contains('active')) return

    this.removeActiveClass()
    event.currentTarget.classList.add('active')

    const productHandle = event.currentTarget.dataset.productHandle
    const productCollection = event.currentTarget.dataset.productCollection

    if (productCollection == 'teas') {
      const productObj = this.collectionJson.find(
        (product) => product.handle === productHandle
      )

      this.updateFeaturedProduct(productObj, 'teas')
    } else if (productCollection == 'greeting-card') {
      const productObj = this.greetingCardJson.find(
        (product) => product.handle === productHandle
      )

      this.updateFeaturedProduct(productObj, 'greeting-card')
    }
  }

  updateFeaturedProduct(product, collection) {
    const featuredUrl = this.querySelector(
      `.js-featured-product-url--${collection}`
    )
    const featuredTitle = this.querySelector(
      `.js-featured-product-title--${collection}`
    )
    const featuredImage = this.querySelector(
      `.js-featured-product-image--${collection}`
    )
    const featuredDescription = this.querySelector(
      `.js-featured-product-description--${collection}`
    )
    const featuredTags = this.querySelector(
      `.js-featured-product-tags--${collection}`
    )

    featuredTitle.textContent = product.title

    if (product?.images[1]?.src != undefined) {
      const srcset = this.generateImgSrcset(product.images[1])

      let image = `<img srcset="${srcset}" src="${product.images[1].src}" loading="lazy" alt="${product.title}" width="${product.images[1].width}" height="${product.images[1].height}" class="product-media">`

      featuredImage.innerHTML = image
    } else if (product?.images[0]?.src != undefined) {
      const srcset = this.generateImgSrcset(product.images[0])

      let image = `<img srcset="${srcset}" src="${product.images[0].src}" loading="lazy" alt="${product.title}" width="${product.images[0].width}" height="${product.images[0].height}" class="product-media">`

      featuredImage.innerHTML = image
    }

    featuredDescription.textContent =
      product?.tea_chest_customizer?.description ||
      product?.description.entry ||
      product?.description.default

    let tagContainer = ''
    product?.tea_chest_customizer?.tags.forEach((tag) => {
      tagContainer += `<p class="mb0">${tag}</p>`
    })

    if (featuredTags) featuredTags.innerHTML = tagContainer

    if (product?.pdp_tf_select?.url != undefined) {
      if (featuredUrl)
        featuredUrl.setAttribute('href', product?.pdp_tf_select?.url)
    } else {
      if (featuredUrl) featuredUrl.setAttribute('href', product.url || '#')
    }
  }

  generateImgSrcset(imgObj) {
    const imageWidth = imgObj.width
    const imageSrc = imgObj.src
    const widths = [
      160, 240, 320, 480, 640, 768, 1024, 1280, 1366, 1440, 1600, 1920, 2560,
    ]

    let srcset = ''

    widths.forEach((width) => {
      if (imageWidth > width) {
        srcset += `${imageSrc}&amp;width=${width} ${width}w,`
      }
    })

    return srcset
  }

  formatPrice(num, fraction = 2) {
    return (
      '$' +
      (Number(num) / 100).toFixed(2).toLocaleString('en-EN', {
        minimumFractionDigits: fraction,
      })
    )
  }

  updateMaxInput(input, max) {
    this.productCards.forEach((elem) => {
      const quantitySelector = elem.querySelector('hh-quantity-selector')

      if (
        elem.getAttribute('is-added') == 'true' ||
        elem.getAttribute('is-tea') == 'false'
      )
        return

      quantitySelector.setAttribute('max', max)

      this.remainingProduct == 0
        ? quantitySelector.setAttribute('is-full', 'true')
        : quantitySelector.setAttribute('is-full', 'false')
    })
  }

  disableOtherGiftCards(input) {
    this.greetingCards.forEach((elem) => {
      const quantitySelector = elem.querySelector('hh-quantity-selector')
      if (elem.getAttribute('product-id') == input) return

      elem.setAttribute('is-added', 'false')
      quantitySelector.setAttribute('is-added', 'false')
    })
  }

  isFull(remaining) {
    const iconCheck = this.querySelector(
      '.js-select-layer-label[data-step="selection"] .icon-check'
    )
    const btnNext = this.querySelector('.select-teas-btn__next')

    if (remaining == 0) {
      iconCheck.classList.add('is-full')
      btnNext.setAttribute('aria-disabled', 'false')
      btnNext.removeAttribute('disabled')
    } else {
      iconCheck.classList.remove('is-full')
      btnNext.setAttribute('aria-disabled', 'true')
      btnNext.setAttribute('disabled', 'true')
      if (this.greetingCardHandle) {
        this.greetingStep.classList.remove('active')
        this.greetingStep
          .querySelector('.step-counter')
          .setAttribute('disabled', 'true')
        this.greetingStep
          .querySelector('.step-counter')
          .setAttribute('aria-disabled', 'true')
      }
      this.reviewStep.classList.remove('active')
      this.reviewStep
        .querySelector('.step-counter')
        .setAttribute('disabled', 'true')
      this.reviewStep
        .querySelector('.step-counter')
        .setAttribute('aria-disabled', 'true')
    }
  }

  toggleProduct(id) {
    const product = this.collectionJson.find((product) => product.id === id)

    const isCurrentlySelected = this.selectedProducts.some(
      (item) => item.id === product.id
    )

    if (isCurrentlySelected) {
      this.selectedProducts = this.selectedProducts.filter(
        (item) => item.id !== product.id
      )
    } else {
      product.quantity = parseInt(this.quantityValue)
      this.selectedProducts = [...this.selectedProducts, product]
    }
  }

  toggleGreetingProduct(id) {
    const product = this.greetingCardJson.find((product) => product.id === id)

    if (product.id === this.selectedGreetingCard.id) {
      this.selectedGreetingCard = this.emptyGreetingCard
    } else {
      this.selectedGreetingCard = {}
      this.selectedGreetingCard = product
    }
  }

  goToNextStep(event) {
    const nextStep = event.target.getAttribute('next-step')
    nextStep == 'greeting' ? this.goToGreeting(event) : this.goToReview(event)
  }

  goToSelection(event) {
    const step = event.target.getAttribute('step')
    this.setAttribute('current-step', step)

    this.selectionStep.classList.remove('completed')
    this.selectionStep.classList.add('active')

    if (this.greetingCardHandle)
      this.greetingStep.classList.remove('active', 'completed')

    this.reviewStep.classList.remove('active')
  }

  goToGreeting(event) {
    const step = event.target.getAttribute('step')
    this.setAttribute('current-step', step)

    this.selectionStep.classList.remove('active')
    this.selectionStep.classList.add('completed')

    if (!this.alreadyOnReview) {
      this.selectionStep
        .querySelector('.step-counter')
        .removeAttribute('disabled')
      this.selectionStep
        .querySelector('.step-counter')
        .setAttribute('aria-disabled', 'false')
    }

    this.greetingStep.classList.add('active')
    this.greetingStep.querySelector('.step-counter').removeAttribute('disabled')
    this.greetingStep
      .querySelector('.step-counter')
      .setAttribute('aria-disabled', 'false')

    this.greetingStep.classList.add('active')
    this.reviewStep.classList.remove('active')
  }

  goToReview(event) {
    this.alreadyOnReview = true
    const step = event.target.getAttribute('step')
    this.setAttribute('current-step', step)
    this.selectionStep.classList.add('completed')
    this.selectionStep
      .querySelector('.step-counter')
      .removeAttribute('disabled')
    this.selectionStep
      .querySelector('.step-counter')
      .setAttribute('aria-disabled', 'false')
    if (this.greetingCardHandle) {
      this.greetingStep.classList.add('completed')
      this.greetingStep.classList.remove('active')
    }
    this.reviewStep.classList.add('active')
    this.reviewStep.querySelector('.step-counter').removeAttribute('disabled')
    this.reviewStep
      .querySelector('.step-counter')
      .setAttribute('aria-disabled', 'false')

    this.generateBoxedProducts()
    if (this.greetingCardHandle) this.generateGreetingCard()
  }

  boxedProducts() {
    const layers = ['top']

    return layers.reduce((acc, curLayer) => {
      const layerItems = []

      this.selectedProducts.forEach((item) => {
        ;[...Array(item.quantity)].forEach(() => {
          layerItems.push(item)
        })
      })

      return {
        ...acc,
        [curLayer]: layerItems,
      }
    }, {})
  }

  generateBoxedProducts() {
    const layerItems = this.boxedProducts()
    const boxedProductWrapper = this.querySelector('.js-review-box-wrapper')
    const boxedProductWrapper2 = this.querySelector('.js-review-box-wrapper-2')
    let topLayer = ''
    let bottomLayer = ''

    layerItems.top.forEach((item, index) => {
      const srcset = this.generateImgSrcset(item.images[2])
      const srcsetHover = this.generateImgSrcset(item.images[1])
      if (index < 4) {
        topLayer += `<div class="form-select-teas__reviews__product-box">
          <div class="form-select-teas__reviews__product-box-base">
            <span>${index + 1}</span>
            <div class="chest-preview">
              <img srcset="${srcset}" src="${
          item.images[2].src
        }" loading="lazy" alt="${item.title}" width="${
          item.images[2].width
        }" height="${item.images[2].height}">
            </div>
            <div class="chest-preview-hover">
              <img srcset="${srcsetHover}" src="${
          item.images[1].src
        }" loading="lazy" alt="${item.title}" width="${
          item.images[1].width
        }" height="${item.images[1].height}">
            </div>
          </div>
        </div>`
      } else {
        bottomLayer += `<div class="form-select-teas__reviews__product-box">
          <div class="form-select-teas__reviews__product-box-base">
            <span>${index + 1}</span>
            <div class="chest-preview">
              <img srcset="${srcset}" src="${
          item.images[2].src
        }" loading="lazy" alt="${item.title}" width="${
          item.images[2].width
        }" height="${item.images[2].height}">
            </div>
            <div class="chest-preview-hover">
              <img srcset="${srcsetHover}" src="${
          item.images[1].src
        }" loading="lazy" alt="${item.title}" width="${
          item.images[1].width
        }" height="${item.images[1].height}">
            </div>
          </div>
        </div>`
      }
    })

    boxedProductWrapper.innerHTML = topLayer
    if (bottomLayer) boxedProductWrapper2.innerHTML = bottomLayer
  }

  generateGreetingCard() {
    const giftCardSelectedLabel = this.querySelector('.js-selected-gift-card')
    const html = `${
      this.selectedGreetingCard?.title
    } Selected - ${this.formatPrice(this.selectedGreetingCard?.price)}`
    giftCardSelectedLabel.innerHTML = html
  }

  generateBundle() {
    const pairValues = this.selectedProducts.reduce((acc, cur) => {
      const { [cur.id]: id = 0, ...rest } = acc

      return {
        ...rest,
        [cur.id]: id + cur.quantity,
      }
    }, {})

    return Object.entries(pairValues)
      .map(([key, value]) => `${key}x${value}`)
      .join('|')
  }

  generateBundleNames() {
    const pairValues = this.selectedProducts.reduce((acc, cur) => {
      const { [cur.id]: id, ...rest } = acc
      const prevCount = id?.count || 0

      return {
        ...rest,
        [cur.id]: {
          title: cur?.title,
          count: prevCount + cur.quantity,
        },
      }
    }, {})

    return Object.values(pairValues)
      .map(({ title }) => `${title}`)
      .join(', ')
  }

  async addToBag() {
    const timestamp = `${Date.now()}`
    const bundle = this.generateBundle()
    const bundleNames = this.generateBundleNames()

    const bundledProducts = this.selectedProducts.map((item) => {
      return {
        id: parseInt(item.variants[0].id),
        quantity: item.quantity,
        properties: {
          _group: timestamp,
          _bundle: bundle,
          _bundle_item: true,
        },
      }
    })

    const greetingCard =
      this.selectedGreetingCard?.id && this.selectedGreetingCard?.id !== '0'
        ? {
            id: this.selectedGreetingCard.variants[0].id,
            quantity: this.selectedGreetingCard.quantity,
            properties: {
              _group: timestamp,
            },
          }
        : null

    const productItems = {
      items: [
        {
          id: this.activeVariant,
          quantity: 1,
          properties: {
            _group: timestamp,
            _bundle: bundle,
            _bundle_items: bundleNames,
          },
        },
        ...bundledProducts,
      ],
    }

    if (greetingCard) {
      productItems.items.push(greetingCard)
    }

    const response = await addToCart(productItems)

    reRenderShopifySections(response)

    if (this.showMiniCartAfterSubmission) {
      utils.toggle(document.body, ['mini-cart-is-active'])
    }

    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'cart-notification',
        },
      })
    )

    this.modal.setAttribute('open', 'false')
  }

  render() {
    return html`<slot
      @goToNextStep="${this.goToNextStep}"
      @goToSelection="${this.goToSelection}"
      @goToGreeting="${this.goToGreeting}"
      @goToReview="${this.goToReview}"
      @addToBag="${this.addToBag}"
    ></slot>`
  }
}

customElements.define('hh-form-select-teas', HHFormSelectTeas)
